// ! 2024 tem 2030 is met een schatting ingevuld. 
// ! Annelies van den bosch zou de echte cijfers moeten doorgeven (notitie van 22/08/2025 by R.A.)
// ! EDIT: updated with real values from Annelies on 29/08/2025 -> all good now

const schoolVakantiesUren = {
  "2019": { "1": 9, "2": 15, "3": 45, "4": 14 },
  "2020": { "1": 8, "2": 14, "3": 44, "4": 15 },
  "2021": { "1": 6, "2": 14, "3": 44, "4": 10 },
  "2022": { "1": 6, "2": 14, "3": 44, "4": 10 },
  "2023": { "1": 6, "2": 14, "3": 44, "4": 10 },
  "2024": { "1": 9, "2": 14, "3": 44, "4": 13 },
  "2025": { "1": 8, "2": 14, "3": 42, "4": 14 },
  "2026": { "1": 7, "2": 14, "3": 43, "4": 15 },
  "2027": { "1": 9, "2": 11, "3": 43, "4": 11 },
  "2028": { "1": 10, "2": 15, "3": 42, "4": 10 },
  "2029": { "1": 10, "2": 14, "3": 44, "4": 12 }
};

export default schoolVakantiesUren
